import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ggc_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ggc_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.lookup_key === product.lookup_key);
      if (found) {
        return prev.map((i) =>
          i.lookup_key === product.lookup_key ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [
        ...prev,
        {
          lookup_key: product.lookup_key,
          name: product.name,
          price: product.price,
          image: product.image,
          quantity: 1,
        },
      ];
    });
    setOpen(true);
  };

  const removeItem = (lookup_key) =>
    setItems((prev) => prev.filter((i) => i.lookup_key !== lookup_key));

  const updateQty = (lookup_key, delta) =>
    setItems((prev) =>
      prev
        .map((i) =>
          i.lookup_key === lookup_key ? { ...i, quantity: Math.max(1, i.quantity + delta) } : i
        )
        .filter((i) => i.quantity > 0)
    );

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQty, clear, count, total, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
